<template>
  <v-dialog
    id="fullscreenDialog"
    fullscreen
    v-model="$store.getters.createMode"
    hide-overlay
    transition="dialog-top-transition"
    :close-delay="500"
    persistent
  >
    <div class="contentWrapper">

      <v-toolbar dark color="#041E42">
        <h1 :class="{'ml-15': $vuetify.breakpoint.mdAndUp, 'ml-12': $vuetify.breakpoint.smAndDown}"
            :style="$vuetify.breakpoint.xs ? {'font-size': '16px'} : {'font-size': '20px'}">
          Create notification
        </h1>
        <v-btn
          :small="$vuetify.breakpoint.smAndDown"
          icon
          dark
          @click="closeCreateMode"
          class="ml-0 close--button"
          aria-label="close">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-row justify="center" :class="{'mt-10': $vuetify.breakpoint.mdAndUp, 'mt-1': $vuetify.breakpoint.smAndDown}">
        <v-col lg="8" md="10" sm="12" cols="12" class="py-0">
          <v-stepper v-model="currentStep" class="elevation-0" alt-labels style="background-color: transparent;">
            <v-stepper-header class="elevation-0" id="stepperHeader">
              <template
                v-for="(step, index) in stepperHeaders"
              >
                <v-stepper-step
                  :key="index"
                  :step="index + 1"
                  :color="currentStep === index + 1 ? '#041e42' : step.status === 'complete' ? '#00a908' : '#ffffff'"
                  :complete="currentStep > index + 1"
                  error-icon="mdi-exclamation"
                  :rules="[() => step.status === 'incomplete' && currentStep > index + 1 ? false : true]"
                  :editable="currentStep > index + 1"
                  edit-icon="$complete"
                >
                  <span
                    :class="{'currentStep': currentStep === (index + 1)}"
                    style="text-align: center;"
                  >{{ step.name }}</span>
                </v-stepper-step>
                <v-divider
                  v-show="$vuetify.breakpoint.smAndUp"
                  v-if="index !== stepperHeaders.length - 1"
                  :key="`step-divider-${index}`"
                />
              </template>
            </v-stepper-header>

            <v-stepper-content step="1"
                               :class="{'stepperContent pt-2': $vuetify.breakpoint.smAndUp, 'stepperContent pt-0 px-0': $vuetify.breakpoint.xsOnly}">
              <NotificationStepOne
                v-if="currentStep === 1"
                @progress="nextStep(2)"
                @close="closeAndSave"
              ></NotificationStepOne>
            </v-stepper-content>

            <v-stepper-content step="2"
                               :class="{'stepperContent pt-2': $vuetify.breakpoint.smAndUp, 'stepperContent pt-0 px-0': $vuetify.breakpoint.xsOnly}">
              <NotificationStepTwo
                v-if="currentStep === 2"
                @progress="nextStep(3)"
                @close="closeAndSave"
              ></NotificationStepTwo>
            </v-stepper-content>

            <v-stepper-content step="3"
                               :class="{'stepperContent pt-2': $vuetify.breakpoint.smAndUp, 'stepperContent pt-0 px-0': $vuetify.breakpoint.xsOnly}">
              <NotificationStepThree
                v-if="currentStep === 3"
                @progress="nextStep(4)"
                @close="closeAndSave"
              ></NotificationStepThree>
            </v-stepper-content>

            <v-stepper-content step="4"
                               :class="{'stepperContent pt-2': $vuetify.breakpoint.smAndUp, 'stepperContent pt-0 px-0': $vuetify.breakpoint.xsOnly}">
              <NotificationStepFour
                v-if="currentStep === 4"
                @progress="sendForApproval()"
                @close="closeAndSave"
              ></NotificationStepFour>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>

    </div>
  </v-dialog>
</template>

<script>
// @ is an alias to /src
import NotificationStepOne from "../../components/qPlus/NotificationStepOne";
import NotificationStepTwo from "../../components/qPlus/NotificationStepTwo";
import NotificationStepThree from "../../components/qPlus/NotificationStepThree";
import NotificationStepFour from "../../components/qPlus/NotificationStepFour";

export default {
  name: 'notification',
  components: {
    NotificationStepFour,
    NotificationStepThree,
    NotificationStepOne,
    NotificationStepTwo
  },
  data() {
    return {
      currentStep: 1,
      steps: 4,
      stepperHeaders: [
        {name: 'Setup', status: 'incomplete'},
        {name: 'Message Content', status: 'incomplete'},
        {name: 'Audience, Approver and Scheduling', status: 'incomplete'},
        {name: 'Review', status: 'complete'},
      ],
      vertical: false,
      altLabels: false,
      editable: false,
    }
  },
  methods: {
    nextStep(step) {
      switch (step) {
        case 2:
          this.stepperHeaders[0].status = 'complete';
          break;
        case 3:
          this.stepperHeaders[1].status = 'complete';
          break;
        case 4:
          this.stepperHeaders[2].status = 'complete';
      }
      if (this.currentStep !== this.steps) {
        this.currentStep = step;
      }
    },
    sendForApproval() {
      this.$store.dispatch('sendForApproval')
        .finally(() => {
          this.$store.commit('setCreateMode', false);
          this.$router.push({name: "qPlusNotifications"});
        })
    },
    closeCreateMode() {
      this.$store.commit('setCreateMode', false);
      this.$router.push({name: "qPlusNotifications"});
    },
    closeAndSave() {
      if (this.$store.getters.currentNotification !== null) {
        if (this.$store.getters.currentNotification.status !== 'Rejected') {
          this.$store.commit('setShowAlert', true);
          setTimeout(() => {
            this.$store.commit('setShowAlert', false);
          }, 2000);
        }
      }
      this.$store.commit('setCreateMode', false);
      this.$router.push({name: "qPlusNotifications"});
    },
    isComplete(obj) {
      if (obj === {} || Object.entries(obj).some(entry => {
        if (entry[1] === null) {
          return true;
        }
      })) return 'incomplete';
      for (let entry of Object.entries(obj)) {
        if (typeof entry[1] === 'object') {
          if (this.isComplete(entry[1]) === 'incomplete') return 'incomplete';
        }
      }
      return 'complete';
    }
  },
  created() {
    const currentNotification = this.$store.getters.currentNotification;
    if (currentNotification) {
      this.currentStep = currentNotification.draftPage < 4 ? currentNotification.draftPage + 1 : 4;
      this.stepperHeaders[0].status = this.isComplete(this.$store.getters.notificationSetupDetails); // 1
      this.stepperHeaders[1].status = this.isComplete(this.$store.getters.notificationMessageDetails); // 2
      this.stepperHeaders[2].status = this.isComplete(this.$store.getters.notificationAudienceAndScheduling); // 3
    }
  },
}
</script>

<style scoped>
.contentWrapper {
  background-color: #F4F4F7;
  min-height: 100%;
  overflow-x: clip;
}

::v-deep .stepperContent .v-stepper__wrapper {
  padding: 4px;
}

.close--button {
  position: absolute;
}

.close--button:focus {
  border: 2px solid #ffffff !important;
  border-radius: 50% !important;
  outline: none !important;
}

::v-deep span.v-stepper__step__step {
  height: 40px;
  width: 40px;
  font-size: 18px;
  font-weight: bold;
}

@media only screen and (min-width: 600px) and (max-width: 959px) {
  ::v-deep.v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: inline !important;
    text-align: center !important;
  }
}

::v-deep .v-stepper__step--inactive span.v-stepper__step__step {
  background-color: #FFFFFF !important;
  border: 2px solid #041E42;
  color: #041E42;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 44px -55px 0 !important;
}

::v-deep.theme--light.v-stepper .v-stepper__label {
  color: #000000;
  line-height: 20px;
}

::v-deep.v-stepper .v-stepper__step.v-stepper__step--error .v-stepper__step__step {
  border: 2px solid #B81237;
  background-color: #FFFFFF;
  color: #B81237;

  i {
    font-size: 1.8rem;
  }
}

span.currentStep {
  font-weight: 600 !important;
}

@media only screen and (max-width: 600px) {
  ::v-deep.stepperContent .v-stepper__wrapper {
    padding: 0 !important;
  }

  .v-stepper__header {
    flex-wrap: nowrap;
  }

  .v-stepper__step {
    padding: 12px;
  }

  #stepperHeader > hr {
    display: inline-block !important;
  }

  ::v-deep.v-stepper--alt-labels .v-stepper__header .v-divider {
    margin: 33px -10px 0 !important;
    padding: 0 5vw;
  }
}
</style>
